<ng-template #iconRef>
	<svg fill="none" height="73" viewBox="0 0 73 73" width="73" xmlns="http://www.w3.org/2000/svg">
		<circle cx="36.5" cy="36.5" fill="#E94444" fill-opacity="0.1" r="36.5"/>
		<path
			d="M37 59C24.5736 59 14.5 48.9264 14.5 36.5C14.5 24.0736 24.5736 14 37 14C49.4264 14 59.5 24.0736 59.5 36.5C59.4864 48.9208 49.4208 58.9864 37 59ZM34.75 43.25V47.75H39.25V43.25H34.75ZM34.75 25.25V38.75H39.25V25.25H34.75Z"
			fill="#E94444"/>
	</svg>
</ng-template>
<app-kamona-dialog [dialogDesign]="modalDesign" [icon]="iconRef" [kamonaDialogType]="dialogType">
	<div>
		<app-kamona-maximize-mobile-dialog (emitAction)="continue()" [buttonName]="'Continue'"
										   [description]="description" [loading]="false"
										   [mobileMessageType]="messageType" [title]="title">
		</app-kamona-maximize-mobile-dialog>
	</div>
</app-kamona-dialog>
